"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Button } from "@/components/ui/button";
const wp_query_params = {
  per_page: 4,
  orderby: "date",
  order: "desc"
};
const wp_query = new WP_Query(wp_query_params);
function DailyEssentialsConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div className="grid grid-cols-2 gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="flex flex-col space-y-4">
            <div className="aspect-[2/3] w-full animate-pulse bg-muted/50 rounded-lg" />
            <div className="h-4 w-2/3 animate-pulse bg-muted/50 rounded-sm" />
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="py-12 text-center text-sm text-muted-foreground font-default">
        Failed to load our seasonal blooms.
      </div>;
  }
  if (products.length === 0) {
    return <div className="py-12 text-center text-sm text-muted-foreground font-default">
        No seasonal picks found at the moment.
      </div>;
  }
  return <div className="grid grid-cols-2 gap-3 sm:grid-cols-2 lg:grid-cols-4">
      {products.map((product, i) => <div key={product.id} data-index={i} className="group relative flex flex-col bg-card border border-dotted border-border/60 rounded-3xl overflow-hidden transition-all duration-300 hover:border-primary/30">
          <div className="relative aspect-[2/3] w-full overflow-hidden bg-secondary/30">
            <Link to={product.link} className="block h-full w-full">
              {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="h-full w-full object-cover transition-transform duration-1000 ease-out group-hover:scale-110" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center bg-muted text-muted-foreground font-default">
                  Floral Art
                </div>}
            </Link>
          </div>

          <div className="pt-4 px-2 pb-3">
            <Link to={product.link} className="block">
              <h3 className="font-default text-xs font-medium leading-snug text-foreground transition-colors hover:text-primary">
                {product.title}
              </h3>
            </Link>
            <div className="mt-2">
              <AddToCartButton productId={product.id} variant="outline" size="sm" buttonClassName="bg-primary text-primary-foreground" text="Add to Cart" showQuantity={false} />
            </div>
          </div>
        </div>)}
    </div>;
}
export default function DailyEssentials() {
  return <section data-section-id="222868" id="aucklands-seasonal-picks" className="bg-background text-foreground py-12 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 flex flex-col items-start justify-between gap-8 md:flex-row md:items-end">
          <div className="max-w-2xl space-y-6">
            <h2 className="font-default text-4xl font-semibold tracking-tight text-foreground sm:text-5xl">Auckland's Seasonal Picks</h2>
            <p className="text-sm text-muted-foreground font-default leading-relaxed hidden sm:block">
              Hand-selected preserved and fresh arrangements, curated for the current season in the heart of Auckland.
            </p>
            {/*  修正：全部产品 → 系统默认/shop */}
            <Button asChild className="rounded-lg bg-primary text-primary-foreground px-8 py-6 text-sm font-medium transition-transform hover:scale-105">
              <Link to="/shop">
                EXPLORE THE FULL COLLECTION →
              </Link>
            </Button>
          </div>
        </div>

        <EcommerceProductsProvider wp_query={{
        include: [482, 478, 471, 15]
      }}>
          <DailyEssentialsConsumer />
        </EcommerceProductsProvider>
      </div>
    </section>;
}